import { setStyleSetting, defaultStyle } from "facepack-solid";
import { deploySelector } from "facepack-solid/SakurairoDeployer";
export default (fp) => {
    setStyleSetting(defaultStyle);
    deploySelector(fp);
};
